import React from "react";

import SearchBar from "../SearchBar";

import styles from "./Header.module.scss";
import DesktopFiltersContainer from "../../containers/DesktopFiltersContainer/DesktopFiltersContainer";
import MobileFiltersContainer from "../../containers/MobileFiltersContainer/MobileFiltersContainer";
import ActiveFiltersContainer from "../../containers/ActiveFiltersContainer/ActiveFiltersContainer";

const Header = (props) => {
    const { isMobile } = props;

    return (
        <div className={styles.header}>
            <div className={styles.header_headercontainer}>
                <SearchBar/>
                {!isMobile && 
                    <ActiveFiltersContainer/>
                }
                {!isMobile &&
                <DesktopFiltersContainer/>
                }

                {isMobile &&
                <MobileFiltersContainer/>
                }

            </div>
        </div>
    )
}
export default Header;
